module.exports = __webpack_public_path__ + "img/yeosu-accessibility-2024.57140965.png";